import React from 'react'
import { useTranslation } from 'react-i18next'
import {
	FaTruck,
	FaPowerOff,
	FaUserCircle,
	FaHistory,
	FaCog,
} from 'react-icons/fa'
import { MdCancel } from 'react-icons/md'

// Consistent style for icons
const iconStyle = { color: 'white', fontSize: '18px' }

/**
 * @typedef {Object} MenuItem
 * @property {string} id - Unique identifier for menu item
 * @property {string} title - Display text
 * @property {string} [path] - Navigation path (optional if action is provided)
 * @property {React.ReactNode} icon - Icon component
 * @property {string} [action] - Special action identifier (e.g., 'logout')
 * @property {Function} [hideWhen] - Function to determine if item should be hidden
 */

/** @type {MenuItem[]} */
export const chauffeurMenuItems = [
	{
		id: 'mes-transports',
		title: 'Mes transports',
		path: '/chauffeur/transports',
		icon: <FaTruck style={iconStyle} />,
	},
	{
		id: 'historique',
		title: 'Historique',
		path: '/chauffeur/historique',
		icon: <FaHistory style={iconStyle} />,
	},
	{
		id: 'annulées',
		title: 'Annulées',
		path: '/annulées/chauffeur',
		icon: <MdCancel style={iconStyle} />,
	},
	{
		id: 'compte',
		title: 'Mon compte',
		path: '/chauffeur/account',
		icon: <FaUserCircle style={iconStyle} />,
	},
	// {
	// 	id: 'logout',
	// 	title: 'Déconnexion',
	// 	icon: <FaPowerOff style={iconStyle} />,
	// 	action: 'logout', // Special action instead of path
	// },
]
